import { render, staticRenderFns } from "./LoyaltyWidgetConfig.vue?vue&type=template&id=5f5ff9a0&scoped=true&"
import script from "./LoyaltyWidgetConfig.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyWidgetConfig.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyWidgetConfig.vue?vue&type=style&index=0&id=5f5ff9a0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5ff9a0",
  null
  
)

export default component.exports